import { render } from "./NotificationMessenger.vue?vue&type=template&id=5721bf9d&scoped=true"
import script from "./NotificationMessenger.vue?vue&type=script&lang=js"
export * from "./NotificationMessenger.vue?vue&type=script&lang=js"

import "./NotificationMessenger.vue?vue&type=style&index=0&id=5721bf9d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5721bf9d"]])

export default __exports__